import React, { Children, PropsWithChildren, ReactElement } from 'react';
import classNames from 'classnames';
import { Cell } from '../grid/Cell';
import { Grid, GridGapSizes } from '../grid/Grid';
import styles from './List.module.scss';

export const List = ({ children, className, gap }: Props) => (
    <Grid direction='column' gap={gap} className={classNames(styles.default, className)}>
        {Children.map(children as ReactElement[], c => (
            <Cell> {c} </Cell>
        ))}
    </Grid>
);

type Props = PropsWithChildren<{
    className?: string;
    gap?: GridGapSizes;
}>;